import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddDiscountModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import SelectCustom from '../../../Global/Select/SelectCustom'
import DummyCounter from '../../../Global/Counter/DummyCounter'

const AddDiscountModal = ({ translate }) => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  const discountsType = [
    {
      id: 1,
      name: 'Абсолютная',
    },
    {
      id: 2,
      name: 'Процентная',
    },
  ]

  return (
    <div className={st.fieldSet}>
      <div className={st.flex}>
        <FormField>
          <FormLabel isRequired>{translate.name}:</FormLabel>
          <FormInput isError={check('name')}>
            <input
              type='text'
              placeholder={translate.name}
              name='name'
              value={modalValue?.name || ''}
              onChange={(e) => changeValue(e.target.value, 'name')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>{translate.discount}:</FormLabel>
          <DummyCounter
            value={modalValue.count || 0}
            min={0}
            max={100}
            name='count'
            step={0.5}
            onChange={(e) => changeValue(e, 'count')}
            isError={check('count')}
          />
        </FormField>
      </div>
      <FormField>
        <FormLabel isRequired>{translate.discount_type}:</FormLabel>
        <SelectCustom
          placeholder={translate.discount_type}
          options={discountsType}
          valueID={modalValue.type}
          onChange={(o) => changeValue(o.id, 'type')}
          error={check('type')}
        />
      </FormField>
    </div>
  )
}

export default observer(AddDiscountModal)
